import React,{useEffect, useState} from "react";
import { Tooltip, withStyles } from "@material-ui/core";
import Badge from '@material-ui/core/Badge';
import {useGlobal} from './../../../../resources/setting/global';
import UtilsObject from './../../../../resources/utils/UtilsObject';

// svg icon
import Brands from "./../../../../assets/personalSVG/panel-brands.svg";
import Process from "./../../../../assets/personalSVG/panel-process.svg";
import Library from "./../../../../assets/personalSVG/panel-library.svg";
import Material from "./../../../../assets/personalSVG/panel-material.svg";
import TextAndShapes from "./../../../../assets/personalSVG/panel-text-and-shapes.svg";
import Filters from "./../../../../assets/personalSVG/panel-effects.svg";
import Settings from "./../../../../assets/personalSVG/panel-settings.svg";
import Finishing from "./../../../../assets/personalSVG/panel-finishing.svg";
import { CloudUploadOutlined } from "@material-ui/icons";

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -3,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
    // firefox padding: '4px 5px 1px 5px',
    // firefox fontSize: 10,
  },
}))(Badge);

const styles = {
  button: {
    width: 45, 
    height: 45, 
    backgroundColor: 'transparent', 
    borderRadius: 7, 
    border: 0, 
    marginBottom: 3,
    textAlign: 'center',
    padding: 0,
    cursor: 'pointer',
  },
};

export default function SectionIcons (props) {

  // HOC
  // https://pt-br.reactjs.org/docs/higher-order-components.html#use-hocs-for-cross-cutting-concerns

  // iOS like border-radius corners react component
  // npm install react-ios-corners
  // import { Squircle } from 'react-ios-corners';
  // <Squircle>Hello</Squircle>
  // https://reactjsexample.com/ios-like-border-radius-corners-react-component/

  const {valGlobal} = useGlobal();
  const [filtersRows, setFiltersRows] = useState( 0 );

  const updateActiveObject = () => {

    UtilsObject.getActive( valGlobal.canvas ).then( object => {

      if( object === null ){
        setFiltersRows(0);
      } else if( object.hasOwnProperty('filters') === false ){
        setFiltersRows(0);
      } else if ( Array.isArray(object.filters) === false ){
        setFiltersRows(0);
      } else {
        setFiltersRows( object.filters.length );
      }
  
    }).catch(()=>setFiltersRows(0));

  }

  const changePanelClick = ( name ) => {
    return props.changePanelClick( name );
  }

  // const changePanelOver = ( name ) => {
  //   return props.changePanelOver( name );
  // }

  useEffect(() => {
    updateActiveObject();
  },[valGlobal]);

  return (
    <React.Fragment>

      <Tooltip title="Brands & Elements" placement="right">
        <button style={styles.button}
          onClick={() => changePanelClick('brands')}
          // onMouseOver={() => changePanelOver('brands')}
        >
          <img src={Brands} style={{ width:35, height:35 }} />
        </button>
      </Tooltip>

      <Tooltip title="Raw Material (MP)" placement="right">
        <button style={styles.button}
          onClick={() => changePanelClick('material')}
          // onMouseOver={() => changePanelOver('material')}
        >
          <img src={Material} style={{ width:25, height:25 }} />
        </button>
      </Tooltip>

      <Tooltip title="Process" placement="right">
        <button style={styles.button}
          onClick={() => changePanelClick('process')}
          // onMouseOver={() => changePanelOver('process')}
        >
          <img src={Process} style={{ width:25, height:25 }} />
        </button>
      </Tooltip>

      <Tooltip title="Personal Uploads" placement="right">
        <button style={styles.button}
          onClick={() => changePanelClick('uploads')}
          // onMouseOver={() => changePanelOver('library')}
        >
          {/* <img src={Library} style={{ width:25, height:25 }} /> */}
          <CloudUploadOutlined fontSize="large" style={{ width:25, height:25 }} />
        </button>
      </Tooltip>

      <Tooltip title="Arts Library & Components" placement="right">
        <button style={styles.button}
          onClick={() => changePanelClick('library')}
          // onMouseOver={() => changePanelOver('library')}
        >
          <img src={Library} style={{ width:25, height:25 }} />
        </button>
      </Tooltip>

      <Tooltip title="Text" placement="right">
        <button style={styles.button}
          onClick={() => changePanelClick("text")}
          // onMouseOver={() => changePanelOver("text")}
        >
          <img src={TextAndShapes} style={{ width:25, height:25 }} />
        </button>
      </Tooltip>

      <Tooltip title="Filters" placement="right">
        <button style={styles.button}
          onClick={() => changePanelClick("filters")}
          // onMouseOver={() => changePanelOver("effects")}
        >
          <StyledBadge badgeContent={ filtersRows } color="secondary" >
          <img src={Filters} style={{ width:26, height:26 }} />
          </StyledBadge>
        </button>
      </Tooltip>

      <Tooltip title="Finishing & Complement" placement="right">
        <button style={styles.button}
          onClick={() => changePanelClick("finishing")}
          // onMouseOver={() => changePanelOver("finishing")}
        >
          <img src={Finishing} style={{ width:25, height:25 }} />
        </button>
      </Tooltip>

      {/* <Tooltip title="Setting Object" placement="right">
        <button style={styles.button}
          onClick={() => changePanelClick("settings")}
          // onMouseOver={() => changePanelOver("settings")}
        >
          <img src={Settings} style={{ width:30, height:30 }} />

        </button>
      </Tooltip> */}

      <center style={{opacity:0.3}}> 
        <a href="javascript:;" onClick={()=>changePanelClick(2)}>2</a> 
        <a href="javascript:;" onClick={()=>changePanelClick(3)}>3</a>  
        <a href="javascript:;" onClick={()=>changePanelClick(6)}>6</a> 
        <a href="javascript:;" onClick={()=>changePanelClick('technicalReport')}>TR</a> 
      </center>

    </React.Fragment>
  );
}
